import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

// NOTE: NSAI-7339 — Zoho Analytics's product mark (without the wordmark) from Zoho's
// own asset (zohowebstatic.com/sites/zweb/images/productlogos/analytics.svg), in the
// brand colour #f70011 (hsl 356 100% 48%), tinted from its own hue like the other
// integration icons. The square viewBox is centred on the mark's bounding box.
const ZohoAnalyticsComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="2.5 0.0 296.0 296.0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="hsl(from hsl(356 100% 48%) h s 48%)"
      d="m269.94,276.48H108.11c-9.23,0-17.5-4.78-22.11-12.78-4.61-8-4.59-17.55.04-25.54l49.74-85.76c3.08-5.31,8.58-8.48,14.71-8.48s11.64,3.17,14.71,8.48l23.74,40.93,28.7-49.47-59.8-103.09c-2.22-3.82-5.88-4.24-7.36-4.24s-5.14.41-7.36,4.24L23.7,246.7c-2.23,3.84-.75,7.23-.01,8.51.74,1.28,2.93,4.26,7.37,4.26h30.4c4.7,0,8.5,3.81,8.5,8.5s-3.81,8.5-8.5,8.5h-30.4c-9.23,0-17.5-4.78-22.11-12.78-4.61-8-4.59-17.55.04-25.54L128.43,32.24c4.62-7.96,12.87-12.71,22.07-12.71s17.45,4.75,22.07,12.71l54.92,94.68,43.37-74.75c2.36-4.06,7.56-5.44,11.62-3.09,4.06,2.36,5.45,7.56,3.09,11.62l-48.26,83.17,54.7,94.3c4.63,7.99,4.65,17.53.04,25.54-4.61,8-12.87,12.78-22.11,12.78Zm-119.44-115.54l-49.74,85.76c-2.23,3.84-.75,7.23-.01,8.51.74,1.28,2.93,4.26,7.37,4.26h161.83c4.44,0,6.63-2.98,7.37-4.26.74-1.28,2.21-4.67-.01-8.51l-49.82-85.88-23.82,41.06c-3.08,5.31-8.58,8.47-14.71,8.47h0c-6.13,0-11.63-3.17-14.71-8.48l-23.74-40.93Z"
    />
    <path
      fill="hsl(from hsl(356 100% 48%) h s 48%)"
      d="m286.97,97.88c-3.76,0-7.2-2.52-8.21-6.32l-6.57-24.73-24.73,6.57c-4.54,1.21-9.2-1.5-10.4-6.04-1.21-4.54,1.5-9.2,6.04-10.4l32.95-8.75c4.54-1.21,9.2,1.5,10.4,6.04l8.75,32.95c1.21,4.54-1.5,9.2-6.04,10.4-.73.19-1.47.29-2.19.29Z"
    />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components.
export const ZohoAnalytics = memo(ZohoAnalyticsComponent);
